module.exports = __webpack_public_path__ + "img/company.c23075db.svg";